<div class="app-container">
  <page-header [icon]="'far-building'" [title]="'depots'">
    <ng-container class="header-button">
      @if (canCreate) {
        <btn
          [routerLink]="['/depot']"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-plus'"
          [label]="'depots.create'"
          [spinnerClassesString]="'spinner-white'"
          [dataCyAttribute]="'go-depot'"
          [title]="'depots.create' | translate"
        ></btn>
      }
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="filters()"
      [filtersForExport]="filters()"
      [entity]="'depots'"
      (onSubmit)="queryDepots.refetch()"
      (onClearClick)="clearFilters()"
      [isFilterInvisible]="true"
      [areExportsInFilter]="false"
      [totalItems]="totalItems()"
    >
      <form-row-input
        [label]="'depots.name'"
        [model]="filters().name"
        (modelChange)="setFilters('name', $event)"
        (keyup.enter)="queryDepots.refetch()"
        [icon]="'far-list'"
        [dataCyAttribute]="'depot-name-filter'"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [listName]="'depots'"
      [query]="queryDepots"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
